import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";
import { initSegment, onSegmentReady } from "./lib/segment";
import { initPostHog } from "./lib/posthog";

// Initialize Segment first, then initialize PostHog when Segment is ready
initSegment();
onSegmentReady(() => {
  initPostHog();
});

createRoot(document.getElementById("root")!).render(<App />);
